import { UnauthorizedUser } from 'Routes/UnauthorizedUser'
import { Container } from './container'
import { RestrictedAccount } from 'pages/RestrictedAccountPage'

export const UnauthorizedAccessRoute = {
    element: <Container />,
    children: [
        {
            path: '/unauthorized_access',
            element: <UnauthorizedUser />,
        },
        {
            path: '/restricted_access',
            element: <RestrictedAccount />,
        },
    ],
}
